import dayjs from "dayjs";
import { Attendance } from "@/@types/esus/Attendance";
import { CitizenExtra } from "@/@types/esus/CitizenExtra";
import { esusApi } from "@/services/api";

export type CitizenWithAttendancesParams = {
	uf: string;
	ibgeCode: string;
	citizenId: number;
	startDate: string;
	endDate: string;
};

export class CitizenWithAttendancesData {
	id: number = 0;
	cns: string = "";
	cpf: string = "";
	fullName: string = "";
	gender: number = 0;
	birthdate: string = "";
	citizenExtra?: CitizenExtra;
	attendances?: Attendance[];
}

export async function getCitizenWithAttendances({
	uf,
	ibgeCode,
	...params
}: CitizenWithAttendancesParams) {
	if (dayjs(params.endDate).diff(dayjs(params.startDate), "days") > 366)
		return new CitizenWithAttendancesData();
	const response = await esusApi.get<CitizenWithAttendancesData>(
		`/uf/${uf}/city/${ibgeCode}/citizen/GetCitizenWithAttendances`,
		params
	);
	return response.data ?? new CitizenWithAttendancesData();
}
